import { render, staticRenderFns } from "./AreaEmbargadaMs.vue?vue&type=template&id=464231b6&lang=pug"
import script from "./AreaEmbargadaMs.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaMs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports